import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { BiLoggerContextProvider, BiDataHook } from '../biLogger';
import Flex from '../Flex';
import Eye from '../Icons/Eye';
import { IconSize } from '../Icons/IconWrap';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import AuthorWatchButton from '../Button/AuthorWatchButton';
import { withMobileContext } from '../Context';
import { formatDate, DATE_FORMATS } from '../Timestamp/functions';
import s from './SubmissionDetails.scss';
var SubmissionDetails = /** @class */ (function (_super) {
    tslib_1.__extends(SubmissionDetails, _super);
    function SubmissionDetails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubmissionDetails.prototype.render = function () {
        var _a = this.props, className = _a.className, title = _a.title, views = _a.views, author = _a.author, t = _a.t, isMature = _a.isMature, isOwner = _a.isOwner, isMobile = _a.isMobile, _b = _a.isLoaded, isLoaded = _b === void 0 ? true : _b;
        var withViews = typeof views !== 'undefined' && isLoaded;
        return (React.createElement("div", { className: classnames(s['root'], className) },
            title && (React.createElement("div", { className: s['title'], "data-hook": BiDataHook.DEVIATION_TITLE }, title)),
            author && (React.createElement(Flex, { alignItems: "center" },
                React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
                    React.createElement(UserAvatar, { user: author, className: s['avatar'], withTooltip: true }),
                    React.createElement("div", { className: s['attribution'] },
                        React.createElement("div", { className: s['author-name'] },
                            React.createElement("span", { className: s['author-by'] },
                                t('deviation.details.by'),
                                ' '),
                            React.createElement(UserLink, { className: s['author-link'], user: author, symbolClassName: s['author-symbol'], withTooltip: true })),
                        !isOwner && isLoaded && (React.createElement(AuthorWatchButton, { author: author, "data-hook": BiDataHook.DEVIATION_WATCH_BUTTON })))))),
            isMobile && isLoaded && (React.createElement("div", { className: s['date'] },
                this.renderTime(withViews),
                withViews && (React.createElement(React.Fragment, null,
                    React.createElement(Eye, { size: IconSize.SMALL, className: s['eye-con'] }),
                    views)),
                isMature && (React.createElement(React.Fragment, null,
                    ' | ',
                    t('deviation.details.matureContent')))))));
    };
    SubmissionDetails.prototype.renderTime = function (renderDivider) {
        var _a = this.props, publishedTime = _a.publishedTime, i18n = _a.i18n;
        if (!publishedTime) {
            return null;
        }
        return (React.createElement("span", { suppressHydrationWarning: true },
            formatDate(publishedTime, DATE_FORMATS.Date.Full, i18n.language),
            renderDivider && ' | '));
    };
    return SubmissionDetails;
}(React.Component));
export { SubmissionDetails };
export default withMobileContext(withTranslation()(SubmissionDetails));
//# sourceMappingURL=SubmissionDetails.js.map